export default {
  API_URL: "https://accounting-new.inkapps.io",
  HOST_URL: "affy-demo.inkapps.io",
}
